"use client";

import { IconUser } from "@tabler/icons-react";
import React from "react";
import { useUserContext } from "../../../providers/UserProvider";
import { useTranslations } from "../../../helpers/translations";

export const MobileSignupAvatar = () => {
  const { currentUserAll } = useUserContext();
  const user = currentUserAll?.data?.me;
  const isLoggedIn = !!user;
  const t = useTranslations("nav");

  if (isLoggedIn) {
    return null;
  }

  return (
    <a
    href={t("footer.signup.href")}
    className="relative flex text-utility-gray-400 hover:text-white py-md px-xs"
    >
      <IconUser width={32} className="shrink-0" />
    </a>
  );
};
